import {useQuery, type UseQueryOptions} from '@tanstack/react-query';
import {
	getCustomActionMenu,
	getCustomActionMenuEndpoint,
	type QueryError,
	type GetCustomActionMenuResult,
	type GetCustomActionMenuRequestOptions,
} from '../getCustomActionMenu';
export * from '../getCustomActionMenu';

export type GetCustomActionQueryParams = GetCustomActionMenuRequestOptions;
export type GetCustomActionQueryKey = [
	string,
	GetCustomActionQueryParams | undefined,
];
export type GetCustomActionQueryOptions = Omit<
	UseQueryOptions<
		GetCustomActionMenuResult,
		QueryError,
		GetCustomActionMenuResult,
		GetCustomActionQueryKey
	>,
	'queryKey' | 'queryFn'
>;

/**
 * react-query wrapper for `getCustomActionMenu`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetCustomActionMenu = (
	queryKeyParams?: GetCustomActionQueryParams,
	options?: GetCustomActionQueryOptions,
) =>
	useQuery<
		GetCustomActionMenuResult,
		QueryError,
		GetCustomActionMenuResult,
		GetCustomActionQueryKey
	>({
		queryKey: [getCustomActionMenuEndpoint, queryKeyParams],
		queryFn: ({queryKey}) => getCustomActionMenu({...queryKey[1]}),
		...options,
	});

export default useReactQueryGetCustomActionMenu;
